import { render, staticRenderFns } from "./PillFilled.vue?vue&type=template&id=c5501b24&"
import script from "./PillFilled.vue?vue&type=script&lang=js&"
export * from "./PillFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports